import { Navigate, useRouterState } from "@tanstack/react-router";
import { useAuth } from "@/hooks/useAuth";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isLoading, session, user, isAdmin, requiresTotp } = useAuth();
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  if (isLoading) {
    return (
      <div className="grid min-h-screen place-items-center bg-background text-sm text-muted-foreground">
        Validando sessao...
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" search={{ next: pathname }} replace />;
  }

  if (requiresTotp) {
    return <Navigate to="/login" search={{ reason: "mfa", next: pathname }} replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/login" search={{ reason: "forbidden" }} replace />;
  }

  if (user?.app_metadata?.admin_mfa_reenroll_required === true && pathname !== "/config") {
    return <Navigate to="/config" search={{ period: "30d" }} replace />;
  }

  return <>{children}</>;
}
